import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_STATS_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_EMPLOYEES_STATS, KEY_GET_EMPLOYEES_STATS } from '../constants';
import { MOCK_RESPONSE_GET_EMPLOYEES_STATS } from '../mocks';

type RequestEmployeesStats = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_STATS_PATH_KEY
>['request']['path'];

type ResponseEmployeesStats = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_STATS_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployeesStats = Omit<RequestEmployeesStats, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployeesStats = ResponseEmployeesStats;

type CallErrorGetEmployeesStats = GenericApiError;

type CallSelectorsGetEmployeesStats = {
  total: number;
  completed: number;
  invalid: number;
};

export const getEmployeesStatsCall = createGeneralCall<
  CallParamsGetEmployeesStats,
  CallResponseGetEmployeesStats,
  CallErrorGetEmployeesStats,
  CallSelectorsGetEmployeesStats
>({
  id: KEY_GET_EMPLOYEES_STATS,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_EMPLOYEES_STATS(org);
  },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYEES_STATS : undefined,
  selectors: {
    total: ({ selectors }) => createSelector(selectors.response, res => res?.total || 0),
    completed: ({ selectors }) => createSelector(selectors.response, res => res?.completed || 0),
    invalid: ({ selectors }) => createSelector(selectors.response, res => res?.invalid || 0),
  },
});
